<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    aria-label="add scenario"
    (click)="onOpenNewScenarioDialog()"
    i18n-matTooltip="@@createNewScenarioTooltip"
    matTooltip="Create a new scenario"
    [matTooltipShowDelay]="1000"
    [disabled]="disabled"
    i18n-aria-label="@@addScenarioAriaLabel"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>
